import { Vue, Component, Prop } from "vue-property-decorator"

@Component
export default class extends Vue {
  @Prop({ required: true })
  name!: string

  @Prop({ default: false })
  active!: boolean

  get src() {
    return `./images/speciality-items/${this.active ? 'surface' : 'mask'}/${this.name}.png`
  }

  @Prop({ default: 80 })
  size!: number

  get boxStyle() {
    const s = this.size
    return {
      height: `${s}px`,
    }
  }
}
